import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Configuração do Firebase para o SystemLoc
const firebaseConfig = {
  apiKey: "AIzaSyBPcgzCSPPSgobp8JcQDnhtkjvq4JPlh5g",
  authDomain: "sistema-aluguel-ternos.firebaseapp.com",
  projectId: "sistema-aluguel-ternos",
  storageBucket: "sistema-aluguel-ternos.firebasestorage.app",
  messagingSenderId: "264130339112",
  appId: "1:264130339112:web:0c4b74ce660e8ab34ef01d"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Inicializar serviços
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Configurar localização para português
auth.languageCode = 'pt-BR';

export default app;
